// extracted by mini-css-extract-plugin
export default {"multipleDeliveriesAlert":"G9c7dda"};